/**
 * this service is private and meant to be used by ThisFlowMixin only!
 */

import { THIS_FLOW_TAB_KEY } from '../../../../DataInput/DataInputMenu/helpers/data-input-menu.const';

// helper methods of service

// methods exported by service
const addThisFlowTabItem = function () {
	const fieldName = 'This Flow';
	this.addTabItem(THIS_FLOW_TAB_KEY, fieldName, false, true);
};

const ThisFlowMixinService = {
	addThisFlowTabItem,
};

export default ThisFlowMixinService;
